<template>
  <section class="chapter2">
    <div class="top">
      <Container>
        <CNumber>02</CNumber>
        <Title dark>Naar buiten</Title>
        <Content dark>
          <p>Oké, tijd voor actie. De deur uit, boodschappen doen. Een drukke straat vermijd je natuurlijk als het even kan. Maar als je depressief bent, klinkt het piepen van de tramrails alsof er een raket wordt afgeschoten. En dat die tram alleen maar piept om jou te irriteren.</p>
        </Content>
        <Statement class="statement">
          Ervaar hoe dat voelt door in deze video de depressiemodus aan of uit te zetten.
        </Statement>
      </Container>
      <VideoSwitch></VideoSwitch>
    </div>
    <div class="bottom">
      <Container>
        <Rorschach
          :poster="poster"
          :src="rorschach"
        >
          Tom
          <AudioPlayer
            :src="audio"
            title="Luister naar Tom"
            person="tom"
            trackTitle="anekdote-tom"
          ></AudioPlayer>
        </Rorschach>
        <PersonContent>
          Als ik me slecht voelde en ik ging naar buiten, stelde ik bij alles om me heen de vraag: waarom overkomt mij dit? Als een stoplicht op rood sprong, voelde dat als een klap in mijn gezicht. Helemaal als anderen verderop door groen reden. Ik kan daarom slecht tegen het openbaar vervoer. Vooral trams, omdat ze altijd piepen. Het voelde alsof ze dat naar mij deden. Dan dacht ik: je kan best even stil voor mij zijn.
        </PersonContent>
        <Accordion :track="track">
          <template slot="explanation">
            <p>Wat je veel ziet bij mensen met een depressie is dat ze situaties personaliseren. Ze denken dat alles betrekking op hen heeft en mensen en situaties zich tegen hen keren. Het heeft iets egocentrisch. Vaak komt bij een depressie ook een verhoogde prikkelbaarheid kijken. Alles komt directer binnen, bijvoorbeeld kleine geluiden op straat. Ook denken ze dat mensen het aan hen kunnen aflezen dat ze depressief zijn.</p>
          </template>
          <template slot="title">Wat zit daarachter?</template>
        </Accordion>
      </Container>
    </div>
  </section>
</template>

<script>
import { CNumber, Title, Content, Container, AudioPlayer } from '@/components/chapter'
import { Rorschach, PersonContent } from '@/components/person'
import Accordion from '@/components/Accordion'
import { VideoSwitch } from '@/components/switch'
import Statement from '@/components/Statement'
import media from '@/utils/media'
import { mediaQueryMixin, scrollPositionMixin, chapterMixin } from '@/mixins'

export default {
  name: 'Chapter2',
  data () {
    return {
    }
  },
  mixins: [mediaQueryMixin, scrollPositionMixin, chapterMixin],
  components: {
    CNumber,
    Title,
    Content,
    Rorschach,
    PersonContent,
    Accordion,
    Container,
    VideoSwitch,
    AudioPlayer,
    Statement
  },
  computed: {
    rorschach () {
      return media.chapter2.rorschach
    },
    poster () {
      return media.chapter2.poster
    },
    audio () {
      return media.chapter2.anekdote
    }
  }
}
</script>

<style lang="scss" scoped>
.chapter2 {
  color: white;
  text-align: left;
}
.top {
  padding-top: 75px;
  background-color: $c-dark;
  position: relative;
  padding-bottom: 40px;

  @media (min-width: 768px) {
    padding-top: 175px;
  }

  &:before {
    content: '';
    background-image: url(~@/assets/images/border.png);
    background-size: 740px 166px;
    background-repeat: repeat;
    background-position: top center;
    height: 166px;
    left: 0;
    right: 0;
    top: -166px;
    position: absolute;
    z-index: 1;
  }
}
.bottom {
  background-color: white;
  padding-bottom: 235px;
}
</style>



// WEBPACK FOOTER //
// src/components/chapters/Chapter2.vue